import type { AttendeeListResponse } from '@@/types/api';
import { useApi } from './use-api';

export function useAttendeesApi() {
  const { get } = useApi('/api/v1/events');

  return {
    getAttendees: (
      eventId: string,
      params?: { page?: number; per_page?: number; sort?: string },
    ) =>
      get<AttendeeListResponse>(`/${eventId}/attendees`, {
        params: params as Record<string, unknown>,
      }),
  };
}
